'use client';

import { LineSearchIcon } from '@/app/_components/icons/line';

interface SearchFilterProps {
  value: string;
  onChange: (value: string) => void;
}

export default function SearchFilter({ value, onChange }: SearchFilterProps) {
  return (
    <div className="gradient-border flex-1 rounded-sm p-px shadow-[0_0_8px_0_var(--color-input-search-box-shadow)] gradient-border-input-search">
      <div className="relative flex h-[42px] items-center rounded-sm bg-card-deco-search-bg px-5">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="찾고 싶은 카드를 검색하세요"
          className="h-full w-full bg-transparent typo-body-6 text-white placeholder:text-input-search-placeholder focus:outline-none"
          autoFocus
        />
        <LineSearchIcon size={16} color="#ffffff" />
      </div>
    </div>
  );
}
